import { render } from "./ChartCriteriaOption.vue?vue&type=template&id=2dd8e6ac"
import script from "./ChartCriteriaOption.vue?vue&type=script&lang=js"
export * from "./ChartCriteriaOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__